var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.tariff) ? _c('v-router-link', {
    attrs: {
      "size": "subheadling",
      "to": {
        path: '/tariff/history'
      }
    }
  }, [_vm._v("\n    Тариф " + _vm._s(_vm.tariff.title) + "\n")]) : _c('v-router-link', {
    attrs: {
      "size": "subheadling",
      "to": {
        name: 'tariff'
      }
    }
  }, [_vm._v("\n    Тариф не выбран\n    "), _c('v-font-icon', {
    directives: [{
      name: "margin",
      rawName: "v-margin.left",
      value: (1),
      expression: "1",
      modifiers: {
        "left": true
      }
    }],
    attrs: {
      "inherit": ""
    }
  }, [_vm._v("add_circle_outline")])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-37129526","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/home/AppBar/Balance.vue
// module id = 1168
// module chunks = 0